// extracted by mini-css-extract-plugin
module.exports = {"landingSection":"LandingSection_landingSection__i8Zpg","landingSectionFixedBG":"LandingSection_landingSectionFixedBG__kk9YH"};